<template>
  <div class="detail consult-page">
    <div class="detail-banner">
      <div class="container">
        <h1>AI 出海专业咨询</h1>
        <div class="sub">企业出海专业服务智能问答 · 法律 / 财务 / 税务 / 合规 / 知识产权 / ODI / 结汇 · 可追溯的公开规则与出处</div>
      </div>
    </div>

    <div class="detail-body">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <!-- ============ 醒目免责提醒（页面首屏固定位置） ============ -->
        <div class="consult-alert">
          <div class="consult-alert-icon">⚠️</div>
          <div class="consult-alert-body">
            <div class="consult-alert-title">重要提示：所有输出结果仅为建议</div>
            <div class="consult-alert-text">
              本页面由 AI 基于公开资料生成，<strong>仅供参考，不构成落地执行方案</strong>，也不能替代执业律师、会计师及合规顾问的正式意见。
              任何事项正式落地前，请务必委托<strong>目标国家/区域的执业机构</strong>进行专项核验。
            </div>
          </div>
        </div>

        <!-- ============ 功能介绍 ============ -->
        <div class="consult-intro">
          <div class="section-title">这个页面能帮你解答什么</div>
          <p class="consult-intro-desc">
            围绕「企业出海」的专业服务问题，结合你的<strong>目标国家/区域</strong>、<strong>所属行业</strong>、<strong>公司规模</strong>与<strong>专业服务领域</strong>，
            梳理关键事项、风险点与办理流程，并给出可追溯的资料出处。
          </p>
          <div class="consult-cap-grid">
            <div class="consult-cap" v-for="c in capabilities" :key="c.title">
              <div class="consult-cap-icon">{{ c.icon }}</div>
              <h3>{{ c.title }}</h3>
              <p>{{ c.desc }}</p>
            </div>
          </div>
        </div>

        <!-- ============ 对话主体 ============ -->
        <AiConsultChat />
      </div>
    </div>
  </div>
</template>

<script>
import AiConsultChat from '../components/AiConsultChat.vue'

export default {
  name: 'AiConsult',
  components: {
    AiConsultChat
  },
  data () {
    return {
      capabilities: [
        { icon: '⚖️', title: '法律与合规', desc: '外资准入、实体设立、数据合规、合同与争议解决等出海法律事项。' },
        { icon: '💰', title: '财务与税务', desc: '跨境资金安排、增值税/所得税、转让定价与税务合规要点。' },
        { icon: '🪪', title: '知识产权与 ODI', desc: '商标专利布局、ODI 境外投资备案与合规申报流程。' },
        { icon: '🌐', title: '行业落地方案', desc: '结合目标市场与行业的准入要求，给出前期/中期/后期办理清单。' }
      ]
    }
  }
}
</script>

<style scoped>
/* ============ 免责提醒 ============ */
.consult-alert {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  background: linear-gradient(135deg, #fff7e6, #fffdf7);
  border: 1px solid #ffd591;
  border-left: 5px solid #fa8c16;
  border-radius: 12px;
  padding: 18px 20px;
  margin-bottom: 24px;
}
.consult-alert-icon {
  font-size: 22px;
  line-height: 1.2;
}
.consult-alert-title {
  font-size: 16px;
  font-weight: 800;
  color: #ad4e00;
  margin-bottom: 6px;
}
.consult-alert-text {
  font-size: 13.5px;
  color: #7c5100;
  line-height: 1.8;
}

/* ============ 功能介绍 ============ */
.consult-intro {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 26px;
  box-shadow: var(--shadow);
  margin-bottom: 24px;
}
.consult-intro .section-title {
  font-size: 22px;
  margin-bottom: 12px;
}
.consult-intro-desc {
  font-size: 14px;
  color: var(--text-sub);
  line-height: 1.85;
  margin-bottom: 20px;
}
.consult-cap-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
.consult-cap {
  background: linear-gradient(160deg, #ffffff, var(--blue-soft-2));
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 18px;
}
.consult-cap-icon {
  font-size: 24px;
  margin-bottom: 8px;
}
.consult-cap h3 {
  font-size: 15.5px;
  color: var(--primary);
  margin-bottom: 8px;
}
.consult-cap p {
  font-size: 13px;
  color: var(--text-sub);
  line-height: 1.75;
}

/* ============ 响应式 ============ */
@media (max-width: 1024px) {
  .consult-cap-grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 560px) {
  .consult-cap-grid {
    grid-template-columns: 1fr;
  }
}
</style>
